import actions from "./actions";

const asaMeetingModule = {
  state: {},
  mutations: {},
  actions,
  getters: {},
};

export default asaMeetingModule;
